import React, { Component } from "react";

const ignoreList = [
  "Morning",
  "News Bulletin",
  "Daytime",
  "Evening",
  "Josh's Hour",
];
const ignorePrefixes = [
  "Purple Playlist"
]

const AlternateScheduleItem = ({ details, day, setSelected }) => {
  let name = details.name;
  const doc = new DOMParser().parseFromString(name, "text/html");
  name = doc.documentElement.textContent;
  let description = "";
  const docdesc = new DOMParser().parseFromString(description, "text/html");
  description = docdesc.documentElement.textContent;
  const descriptionarray = description.split(";");
  //name = decodeURI(name)
  //name = name.replace("&#039;", "'")
  //name = name.replace("&amp;", "&")
  //name = name.replace("&#039;", "'")
  let startTime = 0
  let startTimeText = ""
  if (details.start_timestamp.length == 5){
    startTime = parseFloat(details.start_timestamp.slice(0, 3)) + parseFloat(details.start_timestamp.slice(3, 5)) / 60;
    startTimeText = details.start_timestamp;
  } else{
      startTime =  parseFloat(details.start_timestamp.slice(11, 13)) + parseFloat(details.start_timestamp.slice(14, 16)) / 60;
      startTimeText = details.start_timestamp.slice(11, 16);
  }
  let endTime = 0
  let endTimeText = ""
  if (details.end_timestamp.length == 5){
    endTime = parseFloat(details.end_timestamp.slice(0, 3)) + parseFloat(details.end_timestamp.slice(3, 5)) / 60;
    endTimeText = details.end_timestamp;
  } else{
      endTime =  parseFloat(details.end_timestamp.slice(11, 13)) + parseFloat(details.end_timestamp.slice(14, 16)) / 60;
      endTimeText = details.end_timestamp.slice(11, 16);
  }
  let showLength = endTime - startTime;
  let descriptiondiv = <div></div>;
  let imageurl = "";
  let containerType = "showcontainer";
  if (description != "") {
    containerType = "showcontainerimage";
    descriptiondiv = (
      <div className="showdescription">
        <b>{name}</b>
        {descriptionarray[0]}
      </div>
    );
  }
  if (showLength < 0) {
    showLength += 24;
  }
  const showPercent = showLength * 30;
  const len = details.name.length;
  let nameClass = "col-sm text-center show showname align-middle ";
  let timeClass = "col-sm text-center show showtime-alt tinytext-alt ";
  timeClass += day;
  if (showPercent < 30){
    nameClass += "tinytext-alt";
  } else if (len < 20) {
    nameClass += "largetext-alt";
  } else if (len < 40) {
    nameClass += "midtext-alt";
  } else if (len < 55) {
    nameClass += "smalltext-alt";
  } else {
      nameClass += "tinytext-alt";
  }
  if (startTime < 8) {
    return null;
  }
  if (ignoreList.includes(name) || name.startsWith(ignorePrefixes)) {
    let fillerclass = "showfiller-alt";
    if (name == "News Bulletin") {
      fillerclass += " bulletin transparent_" + day;
    }
    return (
      <div
        className="col-sm showcontainer mobile_hide"
        style={{ paddingTop: showPercent + "%" }}
      >
        <div className="container showfillercontainer" style={{}}>
          <div className="row">
            <div className={fillerclass}>{name}</div>
          </div>
        </div>
      </div>
    );
  }
  let imageblob;
  if (imageurl != "") {
    imageurl = imageurl.replace("localhost", "backend.purpleradio.co.uk");
    nameClass += " hasimage";
    containerType = "showcontainerimage";
    /*
    fetch(imageurl)
      .then(response => response.blob())
      .then(images => {
        imageblob = URL.createObjectURL(images)
        console.log(imageblob)
        return (
          <div className={containerType} style={{paddingTop: showPercent + "%"}}>
            <div className="container shownote" style={{}}>
              <div className="row">
                <div className={timeClass}>
                  {details.start_timestamp.slice(10, 16)}-{details.end_timestamp.slice(10, 16)}
                </div>
              </div>
              <div className="row namebackground">
                <div className="blurredbackground" style={{backgroundImage: `url("${imageblob}")`}}></div>
                <div className={nameClass}  style={{backgroundImage: `url("${imageblob}")`}}>{name}</div>
                {descriptiondiv}
              </div>
            </div>
          </div>
        );
      })*/
  }
  return (
    <div className="notecontainer" style={{ paddingTop: `calc(max(70px, 2vw) + ${(startTime-8) * 30}%` }}>
      <div className={containerType} style={{ paddingTop: showPercent + "%" }} onClick={() => setSelected(details)}>
        <div className="container shownote-alt" style={{}}>
          <div className="row">
            <div className={timeClass}>
              {startTimeText} - {endTimeText}
            </div>
          </div>
          <div className="row namebackground-alt">
            <div
              className="blurredbackground"
              style={{ backgroundImage: `url("${imageurl}")` }}
            ></div>
            <div
              className={nameClass}
              style={{ backgroundImage: `url("${imageurl}")` }}
            >
              {name}
            </div>
            {descriptiondiv}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlternateScheduleItem;
